import { MenuItem } from '@mui/material';
import React, { useState } from 'react';
import { Controls } from '@/main/services/constants/constantsControl';
import {
  getTranslateByKey,
  isShowControlByElementId
} from '@/main/services/utils';
import { useThreeDotsClaimContext } from '../contex';
import WrapperModalClaimBuyerManualAnswer from '@/main/components/shared/boxCart/components/modalBuyerManualAnswer/modalClaimBuyerManualAnswer';

interface IThreeDotsClaimDirectAssignProps {
  guidClaim: string;
  isQuoteManual: boolean;
  isPossibleTotalLoss: boolean;
  guidCompanyBuyer: string;
  onSuccess: (willGenerateOrderAutomatically: boolean) => void;
}

function ThreeDotsClaimDirectAssign({
  guidClaim,
  guidCompanyBuyer,
  isQuoteManual,
  isPossibleTotalLoss,
  onSuccess
}: IThreeDotsClaimDirectAssignProps) {
  const { closeThreeDotsClaim } = useThreeDotsClaimContext();

  const showButtonBuyerManualAnswer =
    isShowControlByElementId(Controls.IdBuyerManualAnswer) &&
    (isQuoteManual || isPossibleTotalLoss);

  const [isOpenModalBuyerManualAnswer, setIsOpenModalBuyerManualAnswer] =
    useState<boolean>(false);

  function handleClickAddManualPartAnswers() {
    setIsOpenModalBuyerManualAnswer(true);
    closeThreeDotsClaim();
  }

  if (!showButtonBuyerManualAnswer) return null;
  return (
    <>
      <MenuItem
        id={`id-option-button-buyerManualAnswer`}
        onClick={handleClickAddManualPartAnswers}>
        {getTranslateByKey('information.buyerManualAnswer')}
      </MenuItem>

      <WrapperModalClaimBuyerManualAnswer
        isOpenModal={isOpenModalBuyerManualAnswer}
        guidCompanyBuyer={guidCompanyBuyer}
        guidClaim={guidClaim}
        onSuccess={onSuccess}
        setIsOpenModal={setIsOpenModalBuyerManualAnswer}
        closeModal={() => setIsOpenModalBuyerManualAnswer(false)}
      />
    </>
  );
}

export { ThreeDotsClaimDirectAssign };
